import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators as bind} from 'redux';
import fields from '../../constants/fieldsForShortenedNewSubmissionForm';
import * as submissionInfoActions from '../../actions/submissionInfoActions';
import { postNewSubmissionAttachments } from '../../actions/attachmentActions';
import Form from '../common/Form/Form';
import ShortenedFormUploadInstructions from './ShortenedFormUploadInstructions';
import sharedFormProps from '../common/Form/SharedFormProps';
import { sharedDispatchToProps, sharedStateToProps } from '../common/Form/SharedReduxToProps';
import PropTypes from 'prop-types';

export class ShortenedSubmissionForm extends Component {
  constructor(props) {
    super(props);

    this.totalSections = 1;
  }

  render() {
    const { submission, postShortenedNewSubmissionInfo } = this.props;
    return (
      <Form
        {...this.props}
        fields={fields}
        label="Lead Submission Form"
        postSubmission={() => postShortenedNewSubmissionInfo(submission)}
        shortenedForm
        title="Quick Submit"
        totalSections={this.totalSections}
        uploadInstructions={
          <ShortenedFormUploadInstructions/>
        }
      />
    );
  }
}

ShortenedSubmissionForm.propTypes = {
  ...sharedFormProps,
  postShortenedNewSubmissionInfo: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    dba: state.submission.name,
    ...sharedStateToProps(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    postSubmissionAttachments: bind(postNewSubmissionAttachments, dispatch),
    postShortenedNewSubmissionInfo: bind(
      submissionInfoActions.postShortenedNewSubmissionInfo,
      dispatch
    ),
    ...sharedDispatchToProps(dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShortenedSubmissionForm);
